<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()

const { accidentPredamages } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <tr v-if="accidentPredamages.display">
    <td>
      <table class="w-full border-collapse">
        <thead>
          <SectionsDetailsPdfElementsHeading colspan="2" as="th">
            {{ accidentPredamages.title }}
          </SectionsDetailsPdfElementsHeading>
        </thead>
        <tbody>
          <tr>
            <td>
              <SectionsDetailsElementsParameters
                :parameters="details.accidentPredamages"
                full-width
              />
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>
